import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=09e029d1&"
import script from "./Legals.vue?vue&type=script&lang=js&"
export * from "./Legals.vue?vue&type=script&lang=js&"
import style0 from "./Legals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports